/**
 * Subscription router
 * @package @app/api
 */

import { findActiveSubscription } from '../middleware/active-subscription';
import { protectedProcedure } from '../middleware/auth';

export const subscriptionRouter = {
  current: protectedProcedure.handler(async ({ context }) => {
    const { db } = context;
    const userId = context.session.user.id;

    // Delegate to the shared picker so this endpoint and createContext
    // (rate-limit tier + plan context) always agree on which row is
    // "current" when the user has multiple subscription rows. See the
    // module for the ranking rule (status priority, then periodEnd,
    // then createdAt).
    const subscription = await findActiveSubscription(db, userId);

    // Surface the rate-limit/plan-gate tier (computed in createContext
    // from session role + active subscription) so the client can mirror
    // the server's isAdminBypass — without this, admin users see
    // plan='free' on the client and the cap-aware UI misroutes them to
    // /pricing even though the server would happily accept the request.
    const tier = context.subscription.tier;

    if (!subscription) {
      return {
        plan: 'free' as const,
        status: 'none' as const,
        periodEnd: null as string | null,
        cancelAtPeriodEnd: false,
        tier,
      };
    }

    return {
      plan: subscription.plan ?? 'free',
      status: subscription.status ?? 'none',
      periodEnd: subscription.periodEnd?.toISOString() ?? null,
      cancelAtPeriodEnd: subscription.cancelAtPeriodEnd,
      tier,
    };
  }),
};
